module.exports = __webpack_public_path__ + "img/80.8.TSS.a1114f14.png";